import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import { Trans } from "react-i18next";

const dropdownPaths = [
  { path: "/admin", state: "adminMenu" },
  { path: "/game", state: "gameMenu" },
  { path: "/user", state: "userMenu" },
  { path: "/agent", state: "agentMenu" },
  { path: "/challenge", state: "challengeMenu" },
  { path: "/transaction", state: "transactionMenu" },
  { path: "/Reports", state: "reportsMenu" },
];

function Sidebar(props) {
  const [menuState, setMenuState] = useState({});

  const isPathActive = (path) => props.location.pathname.startsWith(path);

  const toggleMenuState = (menuKey) => {
    setMenuState((prev) => {
      if (prev[menuKey]) {
        return { ...prev, [menuKey]: false };
      }
      if (Object.keys(prev).length === 0) {
        return { [menuKey]: true };
      }
      const next = {};
      Object.keys(prev).forEach((i) => {
        next[i] = false;
      });
      next[menuKey] = true;
      return next;
    });
  };

  useEffect(() => {
    const sidebar = document.querySelector("#sidebar");
    if (sidebar) {
      sidebar.classList.remove("active");
    }

    setMenuState((prev) => {
      const next = {};
      Object.keys(prev).forEach((i) => {
        next[i] = false;
      });
      dropdownPaths.forEach((obj) => {
        if (props.location.pathname.startsWith(obj.path)) {
          next[obj.state] = true;
        }
      });
      const prevKeys = Object.keys(prev);
      const nextKeys = Object.keys(next);
      const unchanged =
        prevKeys.length === nextKeys.length &&
        nextKeys.every((key) => Boolean(prev[key]) === Boolean(next[key]));
      return unchanged ? prev : next;
    });
  }, [props.location]);

  useEffect(() => {
    const body = document.querySelector("body");
    const items = document.querySelectorAll(".sidebar .nav-item");
    const listeners = [];

    items.forEach((el) => {
      const onMouseOver = () => {
        if (body && body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      };
      const onMouseOut = () => {
        if (body && body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      };
      el.addEventListener("mouseover", onMouseOver);
      el.addEventListener("mouseout", onMouseOut);
      listeners.push({ el, onMouseOver, onMouseOut });
    });

    return () => {
      listeners.forEach(({ el, onMouseOver, onMouseOut }) => {
        el.removeEventListener("mouseover", onMouseOver);
        el.removeEventListener("mouseout", onMouseOut);
      });
    };
  }, []);

  // foreach props
  for (let key in props) {
    if (props[key] === undefined) {
      setTimeout(() => {}, 1000);
    }
  }

  return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
          <a className="brand-logo" href="/dashboard">
            <img
              src="/logo.png"
              alt="logo"
              style={{ width: "70px ", marginLeft: "-40px" }}
            />
          </a>
        </div>
        <div className="sidebar_fixed">
          <ul className="nav">
            {props.dashboard && (
              <li
                className={
                  isPathActive("/dashboard")
                    ? "nav-item menu-items active"
                    : "nav-item menu-items"
                }
              >
                <Link className="nav-link" to="/dashboard">
                  <span className="menu-icon">
                    <i className="mdi mdi-speedometer"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>Dashboard</Trans>
                  </span>
                </Link>
              </li>
            )}
            {/* {props.earnings && (
              <li
                className={
                  isPathActive("/clintPage")
                    ? "nav-item menu-items active"
                    : "nav-item menu-items"
                }
              >
                <Link className="nav-link" to="/clintPage">
                  <span className="menu-icon">
                    <i className="mdi mdi-cash-usd"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>Clint Page</Trans>
                  </span>
                </Link>
              </li>
            )} */}
            {props.earnings && (
              <li
                className={
                  isPathActive("/earinigs")
                    ? "nav-item menu-items active"
                    : "nav-item menu-items"
                }
              >
                <Link className="nav-link" to="/earinigs">
                  <span className="menu-icon">
                    <i className="mdi mdi-cash-usd"></i>
                  </span>
                  <span className="menu-title">
                    <Trans> Admin Earnings</Trans>
                  </span>
                </Link>
              </li>
            )}
            {(props.allAdmins ||
              props.newAdmin ||
              props.sitesettings ||
              props.Gatewaysettings) && (
              <li
                className={
                  isPathActive("/admin")
                    ? "nav-item menu-items active"
                    : "nav-item menu-items"
                }
              >
                <div
                  className={
                    menuState.adminMenu ? "nav-link menu-expanded" : "nav-link"
                  }
                  onClick={() => toggleMenuState("adminMenu")}
                  data-toggle="collapse"
                >
                  <span className="menu-icon">
                    <i className="mdi mdi-account-star"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>Admin Manager</Trans>
                  </span>
                  <i className="menu-arrow"></i>
                </div>
                <Collapse in={menuState.adminMenu}>
                  <div>
                    <ul className="nav flex-column sub-menu">
                      {props.allAdmins && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/admin/alladmins")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/admin/alladmins"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>All Admins</Trans>
                          </Link>
                        </li>
                      )}
                      {props.newAdmin && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/admin/addadmin")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/admin/addadmin"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Add New Admin</Trans>
                          </Link>
                        </li>
                      )}
                      {props.newAdmin && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/user/adminkyc")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/user/adminkyc"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Admin KYC</Trans>
                          </Link>
                        </li>
                      )}
                      {props.sitesettings && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/admin/sitesettings")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/admin/sitesettings"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Website Settings</Trans>
                          </Link>
                        </li>
                      )}
                      {props.Gatewaysettings && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/admin/getwaysettings")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/admin/getwaysettings"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Getway Settings</Trans>
                          </Link>
                        </li>
                      )}
                      <li className="nav-item">
                        <Link
                          className={
                            isPathActive("/admin/bankdetails")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/admin/bankdetails"
                        >
                          <span className="menu-icon">
                            <i className="mdi mdi-arrow-right"></i>
                          </span>{" "}
                          <Trans>Bank Details</Trans>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Collapse>
              </li>
            )}
            {(props.allUsers ||
              props.pendingKyc ||
              props.completedKyc ||
              props.rejectKyc ||
              props.pushNotification) && (
              <li
                className={
                  isPathActive("/user")
                    ? "nav-item menu-items active"
                    : "nav-item menu-items"
                }
              >
                <div
                  className={
                    menuState.userMenu ? "nav-link menu-expanded" : "nav-link"
                  }
                  onClick={() => toggleMenuState("userMenu")}
                  data-toggle="collapse"
                >
                  <span className="menu-icon">
                    <i className="mdi mdi-face"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>User Manager</Trans>
                  </span>
                  <i className="menu-arrow"></i>
                </div>
                <Collapse in={menuState.userMenu}>
                  <div>
                    <ul className="nav flex-column sub-menu">
                      {props.allUsers && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/user/allusers")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/user/allusers"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>View All Users</Trans>
                          </Link>
                        </li>
                      )}
                      {props.pendingKyc && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/user/UserKyc")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/user/UserKyc"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Pending Kyc</Trans>
                          </Link>
                        </li>
                      )}
                      {props.completedKyc && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/user/kyc")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/user/kyc"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Completed Kyc</Trans>
                          </Link>
                        </li>
                      )}
                      {props.rejectKyc && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/user/reject")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/user/reject"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Reject Kyc</Trans>
                          </Link>
                        </li>
                      )}
                      {props.pushNotification && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/user/notification")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/user/notification"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Notification</Trans>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </Collapse>
              </li>
            )}
            {(props.allChallenges ||
              props.completedChallenges ||
              props.conflictChallenges ||
              props.cancelledChallenges ||
              props.runningChallenges ||
              props.newChallenge) && (
              <li
                className={
                  isPathActive("/challenge")
                    ? "nav-item menu-items active"
                    : "nav-item menu-items"
                }
              >
                <div
                  className={
                    menuState.challengeMenu
                      ? "nav-link menu-expanded"
                      : "nav-link"
                  }
                  onClick={() => toggleMenuState("challengeMenu")}
                  data-toggle="collapse"
                >
                  <span className="menu-icon">
                    <i className="mdi mdi-xbox-controller"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>Challenge Manager</Trans>
                  </span>
                  <i className="menu-arrow"></i>
                </div>
                <Collapse in={menuState.challengeMenu}>
                  <div>
                    <ul className="nav flex-column sub-menu">
                      {props.conflictChallenges && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/challenge/conflict_challange")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/challenge/conflict_challange"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Conflict Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {props.runningChallenges && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/challenge/pending_challange")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/challenge/pending_challange"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Pending Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {props.allChallenges && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/challenge/allchallenges")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/challenge/allchallenges"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>View All Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {props.completedChallenges && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive(
                                "/challenge/completed_challange",
                              )
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/challenge/completed_challange"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Completed Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {props.cancelledChallenges && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive(
                                "/challenge/cancelled_challange",
                              )
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/challenge/cancelled_challange"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Cancelled Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {props.runningChallenges && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/challenge/running_challange")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/challenge/running_challange"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Running Challenge</Trans>
                          </Link>
                        </li>
                      )}
                      {props.newChallenge && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/challenge/new_challange")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/challenge/new_challange"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>New Challenge</Trans>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </Collapse>
              </li>
            )}
            {(props.bonus ||
              props.penalty ||
              props.depositHistory ||
              props.depositManual ||
              props.allWithdrawlRequests) && (
              <li
                className={
                  isPathActive("/transaction")
                    ? "nav-item menu-items active"
                    : "nav-item menu-items"
                }
              >
                <div
                  className={
                    menuState.transactionMenu
                      ? "nav-link menu-expanded"
                      : "nav-link"
                  }
                  onClick={() => toggleMenuState("transactionMenu")}
                  data-toggle="collapse"
                >
                  <span className="menu-icon">
                    <i className="mdi mdi-transit-transfer"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>Transaction Manager</Trans>
                  </span>
                  <i className="menu-arrow"></i>
                </div>
                <Collapse in={menuState.transactionMenu}>
                  <div>
                    <ul className="nav flex-column sub-menu">
                      {props.allWithdrawlRequests && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/transaction/allwithdrawl")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/transaction/allwithdrawl"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>All Withdrawl Request</Trans>
                          </Link>
                        </li>
                      )}
                      {props.depositManual && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/transaction/deposit_manual")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/transaction/deposit_manual"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Deposit Manual</Trans>
                          </Link>
                        </li>
                      )}
                      {props.depositHistory && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive(
                                "/transaction/transaction_history",
                              )
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/transaction/transaction_history"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Deposit history</Trans>
                          </Link>
                        </li>
                      )}
                      {props.allWithdrawlRequests && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/transaction/withdraw")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/transaction/withdraw"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Withdrawl history</Trans>
                          </Link>
                        </li>
                      )}
                      {props.bonus && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/transaction/bonus")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/transaction/bonus"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Bonus</Trans>
                          </Link>
                        </li>
                      )}
                      {props.penalty && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/transaction/penalty")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/transaction/penalty"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Penalty</Trans>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </Collapse>
              </li>
            )}
            {/* Added By Team */}
            {(props.bonusReport ||
              props.depositReport ||
              props.penaltyReport ||
              props.withdrawlReport) && (
              <li
                className={
                  isPathActive("/reports")
                    ? "nav-item menu-items active"
                    : "nav-item menu-items"
                }
              >
                <div
                  className={
                    menuState.reportsMenu
                      ? "nav-link menu-expanded"
                      : "nav-link"
                  }
                  onClick={() => toggleMenuState("reportsMenu")}
                  data-toggle="collapse"
                >
                  <span className="menu-icon">
                    <i className="mdi mdi-poll-box"></i>
                  </span>
                  <span className="menu-title">
                    <Trans>Reports</Trans>
                  </span>
                  <i className="menu-arrow"></i>
                </div>
                <Collapse in={menuState.reportsMenu}>
                  <div>
                    <ul className="nav flex-column sub-menu">
                      {props.bonusReport && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/Reports/bonus_report")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/Reports/bonusReport"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>bonus Report</Trans>
                          </Link>
                        </li>
                      )}
                      {props.penaltyReport && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/Reports/penalty_report")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/Reports/penaltyReport"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>penalty Report</Trans>
                          </Link>
                        </li>
                      )}
                      {props.depositReport && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/Reports/deposit_report")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/Reports/depositReport"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>deposit Report</Trans>
                          </Link>
                        </li>
                      )}
                      {props.withdrawlReport && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/Reports/withdrawal_report")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/Reports/withdrawalReport"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>withdrawal Report</Trans>
                          </Link>
                        </li>
                      )}
                      {props.blockUser && (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              isPathActive("/Reports/Blockuser")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/Reports/blockuser"
                          >
                            <span className="menu-icon">
                              <i className="mdi mdi-arrow-right"></i>
                            </span>{" "}
                            <Trans>Block User</Trans>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </Collapse>
              </li>
            )}
          </ul>
        </div>
      </nav>
    );
}

export default withRouter(Sidebar);
